export const UploadType = {
  FILE: "FILE",
  LINK: "LINK",
};

export const ImportEntityType = {
  POST: "POST",
  PUT: "PUT",
};
